import React from "react";
import { CRow } from "@coreui/react";
import { Table, TableHeader, TableRow, TableHeaderCell } from "semantic-ui-react";
import "./f29.scss";

const tableStyle = { tableLayout: "fixed", width: "100%" };

/** Imita el input (+ $ / valor) de las filas F29 */
function F29ModuleSkelInput() {
  return (
    <div className="f29-module-skel-input" aria-hidden>
      <div className="f29-module-skel-input__label" />
      <div className="f29-module-skel-input__field">
        <div className="f29-skeleton-bar f29-skeleton-bar--title" style={{ width: "78%", height: 12, maxWidth: 120 }} />
      </div>
    </div>
  );
}

function GreySectionRowSkeleton({ titleWidth = "min(300px, 58%)", subWidth = "min(240px, 46%)" }) {
  return (
    <Table celled structured className="f29-ui-table" style={tableStyle}>
      <TableHeader>
        <TableRow className="f29-table-header-row">
          <TableHeaderCell colSpan="12" className="f29-table-header-cell">
            <div
              className="f29-skeleton-bar f29-skeleton-bar--title"
              style={{ width: titleWidth, height: 15, marginBottom: 6 }}
            />
            <div className="f29-skeleton-bar f29-skeleton-bar--muted" style={{ width: subWidth, height: 11 }} />
          </TableHeaderCell>
          <TableHeaderCell colSpan="3" className="text-center f29-table-header-cell">
            <F29ModuleSkelInput />
          </TableHeaderCell>
        </TableRow>
      </TableHeader>
    </Table>
  );
}

function DarkSectionRowSkeleton({ withMetaPill = false }) {
  return (
    <Table celled structured className="f29-ui-table" style={tableStyle}>
      <TableHeader>
        <TableRow className="f29-special-section-row">
          <TableHeaderCell colSpan="12" className="f29-special-section-cell">
            <div
              className="f29-skeleton-bar f29-skeleton-bar--on-dark f29-skeleton-bar--title"
              style={{ width: "min(260px, 52%)", height: 15, marginBottom: 6 }}
            />
            <div
              className={`f29-module-skel-dark-sub ${withMetaPill ? "f29-module-skel-dark-sub--with-pill" : ""}`}
            >
              <div
                className="f29-skeleton-bar f29-skeleton-bar--on-dark f29-skeleton-bar--muted"
                style={{ width: "min(200px, 44%)", height: 11 }}
              />
              {withMetaPill ? (
                <div className="f29-skeleton-bar f29-skeleton-bar--on-pill" />
              ) : null}
            </div>
          </TableHeaderCell>
          <TableHeaderCell colSpan="3" className="text-center f29-special-section-cell">
            <F29ModuleSkelInput />
          </TableHeaderCell>
        </TableRow>
      </TableHeader>
    </Table>
  );
}

/**
 * Esqueleto de carga inicial (lazy route).
 * Con Suspense, el Route aún no monta el h1 de Content: reproducimos la misma jerarquía
 * que verá el usuario — título de página + card Propuesta F29 + filas.
 */
export default function F29ModuleLoadingSkeleton() {
  return (
    <div className="f29-module-skel-root" aria-busy="true" aria-live="polite">
      {/* Mismo bloque que Content.js (`route.pageTitle`) cuando la ruta ya cargó */}
      <h1 className="page-title-header">Formulario 29</h1>
      <CRow className="f29-module-skel-row mb-0">
        <div className="f29TableContainer">
          <div className="f29Header">
            <div>
              <h2 className="f29Header__title">
                <div
                  className="f29-skeleton-bar f29-skeleton-bar--title"
                  style={{ width: "min(380px, 82%)", height: 22, maxWidth: "100%" }}
                  aria-hidden
                />
              </h2>
              <p className="f29Header__subtitle">
                <div
                  className="f29-skeleton-bar f29-skeleton-bar--muted"
                  style={{ width: "min(320px, 72%)", height: 13, maxWidth: "100%" }}
                  aria-hidden
                />
              </p>
            </div>
          <div className="f29Header__controls" aria-hidden>
            <div className="f29-skeleton-bar" style={{ width: 112, height: 22, borderRadius: 4 }} />
            <div className="f29-skeleton-bar" style={{ width: 118, height: 22, borderRadius: 4 }} />
            <div className="f29-skeleton-bar f29Header__monthDropdown" style={{ height: 38, borderRadius: 6 }} />
            <div className="f29-skeleton-bar" style={{ width: 188, height: 38, borderRadius: 6 }} />
            <div className="f29-skeleton-bar" style={{ width: 132, height: 38, borderRadius: 6 }} />
          </div>
        </div>
        <div className="f29MainContent f29-module-loading-skel-body">
          <GreySectionRowSkeleton titleWidth="min(280px, 56%)" subWidth="min(220px, 44%)" />
          <GreySectionRowSkeleton titleWidth="min(300px, 60%)" subWidth="min(230px, 45%)" />
          <GreySectionRowSkeleton titleWidth="min(260px, 54%)" subWidth="min(210px, 42%)" />
          <GreySectionRowSkeleton titleWidth="min(290px, 57%)" subWidth="min(225px, 43%)" />
          <DarkSectionRowSkeleton />
          <DarkSectionRowSkeleton />
          <DarkSectionRowSkeleton withMetaPill />
          <DarkSectionRowSkeleton />
        </div>
      </div>
      </CRow>
    </div>
  );
}
